module.exports = __webpack_public_path__ + "assets/img/icon-badge-58c12827.png";